import { LicenceRequest } from "@/types/licence.definition";
import { apiClient } from "../config/api.config";

export function getLicenceByFacility(facilityId: string | number) {
  return apiClient.request({
    method: "get",
    url: `/healthcare-facilities/${facilityId}/licences`,
  });
}

export function getAvailablePlans() {
  return apiClient.request({
    method: "get",
    url: `/licences/plans`,
  });
}

export function createLicence(facilityId: string | number, data: LicenceRequest) {
  return apiClient.request({
    method: "post",
    url: `/healthcare-facilities/${facilityId}/licences`,
    data,
  });
}

export function updateLicence(facilityId: string | number, licenceId: number, data: LicenceRequest) {
  return apiClient.request({
    method: "put",
    url: `/healthcare-facilities/${facilityId}/licences/${licenceId}`,
    data,
  });
}

export function scheduleDoctorRemovals(facilityId: string | number, licenceId: number, doctorIds: number[]) {
  return apiClient.request({
    method: "post",
    url: `/healthcare-facilities/${facilityId}/licences/${licenceId}/schedule-doctor-removals`,
    data: doctorIds,
  });
}

export function addDoctorsNow(facilityId: string | number, licenceId: number, count: number) {
  return apiClient.request({
    method: "post",
    url: `/healthcare-facilities/${facilityId}/licences/${licenceId}/add-doctors`,
    params: { count },
  });
}

export function getDurationDiscounts() {
  return apiClient.request({
    method: "get",
    url: `/licences/duration-discounts`,
  });
}
